import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import LegendWidget from '@arcgis/core/widgets/Legend';
import Sublayer from '@arcgis/core/layers/support/Sublayer';

@Component({
  selector: 'app-legend-layer',
  templateUrl: 'legend-layer.component.html',
  styleUrls: ['legend-layer.component.scss'],
})
export class LegendLayerComponent implements OnChanges, OnDestroy {
  @ViewChild('legendContainerEl', { static: true })
  legendContainerElRef: ElementRef<HTMLDivElement>;

  @Input()
  mapView: __esri.MapView;

  @Input()
  layer: __esri.Layer | __esri.Sublayer;

  private legendWidget: LegendWidget;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.layer) {
      this.legendWidget?.destroy();

      if (this.layer) {
        this.handleLegendWidget();
      }
    }
  }

  ngOnDestroy(): void {
    this.legendWidget?.destroy();
  }

  private async handleLegendWidget() {
    let layer: __esri.Layer;
    let sublayerIds = new Array<number>();

    if (this.layer instanceof Sublayer) {
      layer = this.layer.layer;
      sublayerIds.push(this.layer.id);
    } else {
      layer = this.layer;
    }

    const info: __esri.LegendLayerInfos = {
      layer,
      sublayerIds,
    };

    this.legendWidget = new LegendWidget({
      container: this.legendContainerElRef.nativeElement,
      view: this.mapView,
      layerInfos: [info],
      respectLayerVisibility: false,
      hideLayersNotInCurrentView: false,
    });
  }
}
